aptis.virtualReality.engine.VRMainMenuController = new Class({

	/**
	 * @var {Null|aptis.virtualReality.engine.VREngine}
	 */
	_engine: null,

	initController: function(engine) {
		this._engine = engine;

		const socketConfig = engine.getSocketConfig();

		const worldNameElement = $j('.mainMenu .worldName');
		worldNameElement.text(engine.getName()).attr('title', engine.getName());

		$j('body').on('aptis-world-renamed', function(event, newName) {
			worldNameElement.text(newName).attr('title', newName);
		});

		const sceneNameElement = $j('.mainMenu .sceneName');
		$j('body').on('aptisSceneChanged', (event, newScene) => {
			sceneNameElement.text(newScene.getName()).attr('title', newScene.getPublicName())
		});

		const profileIconElement = $j('.mainMenu .profile');
		if (socketConfig) {
			profileIconElement.append(`
				<div class="mood">
					<aptis-mood moodStatus="1" userAvatar="${encodeURI(socketConfig.userAvatarUrl)}"></aptis-mood>
				</div>
			`);
			profileIconElement.css('background', 'none');
		}

		if (socketConfig && socketConfig.userId) {
			$j('.mainMenu .mood').attr('data-user-id', socketConfig.userId);
		}

		$j('body').on('mouseup', '.mainMenu .fullscreen', (event) => {
			if (engine.isFullScreen()) {
				engine.makeFullScreen();
			} else {
				engine.exitFullScreen();
			}
		});

		$j('body').on('mouseup', '.mainMenu .chat', (event) => {
			$j('body').trigger('aptis-toggle-chat-visibility');
		});

		if (socketConfig) {
			$j('body').on('mouseup', '.mainMenu .profile', (event) => {
				engine.showProfile(socketConfig);
			});
		}

		$j('body').on('mouseup', '.mainMenu .world-settings', (event) => {
			$j('body').trigger('aptis-toggle-scene-settings');
		});

		$j('body').on('mouseup', '.mainMenu .menuLeft .icon:not(.go-back)', (event) => {
			console.log('click');
			$j('body').trigger('aptis-show-scenes-layer');
		});

		$j('body').on('mouseup', '.mainMenu .menuLeft .icon.go-back', (event) => {
			window.location.href = 'https://bagless.io/welten/';
		});

		$j('body').on('aptis-user-mood-changed', (event, userId, newMood) => {
			const affectedUser = $j('.mainMenu').find('[data-user-id=' + userId + ']');
			if (affectedUser.length > 0) {
				affectedUser.find('aptis-mood').attr('moodstatus', newMood);
			}
		});

		$j('body').on('aptis-user-data-updated', (event, userId, newUserData) => {
			if (socketConfig && socketConfig.userId === userId) {
				$j('.mainMenu aptis-mood').attr('userAvatar', newUserData.userAvatarUrl);
			}
		});
	},
});
